import { useEffect, useState } from 'react';
import { paymentApi } from '@vmos2/core';

export const usePaymentProviders = () => {
  const [paymentProviders, setPaymentProviders] = useState([]);

  useEffect(() => {
    paymentApi.get('providers/tenant', { skipAuth: true, cache: { ttl: 3600 * 1000 } })
    .then(setPaymentProviders)
    .catch(error => {
      console.error('Unable to load payment providers\n', error);
    });
  }, []);

  return { paymentProviders };
};
